'use client';

import { useEffect, useRef } from 'react';
import { staggerIn } from '@/utils/gsap';

/**
 * Anima los hijos directos del elemento referenciado con una entrada
 * escalonada al hacer scroll. Respeta prefers-reduced-motion vía el CSS global.
 */
export function useStaggerIn(opts = {}) {
  const ref = useRef(null);
  useEffect(() => {
    const els = ref.current?.querySelectorAll(':scope > *');
    if (!els?.length) return;
    const t = staggerIn(els, ref.current, opts);
    return () => t?.kill();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps
  return ref;
}
